import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import parse from 'html-react-parser';
// import { Link } from 'gatsby';
import Image from '../image/Image';
import { imageWithPrefix } from '../../scripts/helpers';
import { sharedIconsPath } from '../../scripts/data';
import FontIconCards from './FontIconCards';
var FontIconFeatureCards = /*#__PURE__*/function (_React$Component) {
  function FontIconFeatureCards() {
    _classCallCheck(this, FontIconFeatureCards);
    return _callSuper(this, FontIconFeatureCards, arguments);
  }
  _inherits(FontIconFeatureCards, _React$Component);
  return _createClass(FontIconFeatureCards, [{
    key: "render",
    value: function render() {
      var _this = this;
      var classN = this.props.className || '';
      var _this$props = this.props,
        cards = _this$props.cards,
        cardsPerPage = _this$props.cardsPerPage;
      var returnFeaturedCard = function returnFeaturedCard() {
        var featured = _this.props.featured;
        if (!featured) {
          return null;
        }
        return React.createElement("div", {
          className: "col-12 col-xl-4 ".concat(cardsPerPage === 3 ? 'col-lg-4' : 'mb-3 mb-lg-4 mb-xl-0', " position-relative text-decoration-none d-block")
        }, featured.tagText && React.createElement("span", {
          className: "badge border border-white position-absolute"
        }, parse(featured.tagText)), React.createElement("div", {
          className: "d-flex p-3 h-100 p-md-4 rounded-3 text-white bg-purple dark-theme-two-squircles-pattern"
        }, React.createElement(Image, {
          className: "spot-icon-md me-3",
          alt: "".concat(featured.heading, " icon"),
          src: imageWithPrefix("".concat(sharedIconsPath, "/").concat(featured.spotIcon)),
          height: "56",
          width: "56",
          lazyLoading: true
        }), React.createElement("div", null, React.createElement("h3", {
          className: "h5"
        }, typeof featured.heading === 'string' ? parse(featured.heading) : featured.heading), featured.subcopy ? React.createElement("p", {
          className: "body-text-sm mb-0"
        }, typeof featured.subcopy === 'string' ? parse(featured.subcopy) : featured.subcopy) : null, featured.link && featured.ctaText ? React.createElement("a", {
          href: featured.link,
          "data-link-both": "".concat(featured.dataLink),
          className: "btn btn-outline-white mt-5"
        }, parse(featured.ctaText)) : null)));
      };
      return React.createElement("div", {
        className: "row ".concat(cardsPerPage === 3 ? 'gy-3 gy-lg-0' : '', " feature-cards ").concat(classN)
      }, returnFeaturedCard(), React.createElement("div", {
        className: "col-12 ".concat(cardsPerPage === 3 ? 'col-lg-8' : 'col-xl-8')
      }, React.createElement(FontIconCards, {
        headingTag: this.props.headingTag,
        variant: this.props.variant,
        cards: cards,
        cardsPerPage: cardsPerPage - 1,
        className: "h-100 ".concat(cardsPerPage === 3 ? '' : '')
      })));
    }
  }]);
}(React.Component);
export default FontIconFeatureCards;